<ng-template>
  <div class="picker-wrapper">
    <div class="picker-body">
      <!-- Left Panel Start -->
      <div class="left-panel">
        <app-pencil-button
          class="pencil-button medium square option-customization"
          *ngFor="let datepickerRange of datepickerRanges | keyvalue: keepInsertionOrderComparator"
          (clickEvent)="onDatepickerRangeClick(datepickerRange.value)"
          [selected]="pendingSelectionRange.name === datepickerRange.value.name"
        >
          <span>{{ datepickerRange.value.localizedLabel }}</span>
          <app-pencil-icon
            *ngIf="pendingSelectionRange.name === datepickerRange.value.name"
            name="check"
            type="mat-icon"
          ></app-pencil-icon>
        </app-pencil-button>
      </div>
      <!-- Left Panel End -->

      <!-- Date Picker Calendar Start -->
      <div class="date-picker-calendar">
        <mat-calendar
          class="datepicker-mat-calendar"
          [selected]="pendingSelectionRange.range"
          [comparisonStart]="pendingSelectionRange.range.start"
          [comparisonEnd]="pendingSelectionRange.range.end"
          (selectedChange)="this.onCalendarDayClick($event)"
          [maxDate]="todayDate"
          [dateFilter]="dateFilter"
        ></mat-calendar>
      </div>
      <!-- Date Picker Calendar End -->
    </div>

    <!-- Footer Start -->
    <div class="footer">
      <div class="border-div"></div>
      <app-pencil-button
        [label]="'Cancel' | translate"
        class="pencil-button white cancel-customization"
        (clickEvent)="cancelClicked()"
      ></app-pencil-button>

      <app-pencil-button
        [label]="'Apply' | translate"
        [disabled]="!pendingSelectionRange.range.end"
        class="pencil-button primary"
        color="primary"
        (clickEvent)="applyClicked()"
      ></app-pencil-button>
    </div>
  </div>
  <!-- Footer end -->
</ng-template>
